import axios, { CancelTokenSource } from 'axios'
import CdnImage from 'components/core/CdnImage'
import Env from 'Env'
import { AnimatePresence, motion } from 'framer-motion'
import HTTPMethod from 'http-method-enum'
import { SupportPostModel } from 'models/core/SupportPostModel'
import Link from 'next/link'
import React, { ChangeEvent, Fragment, FunctionComponent } from 'react'
import { useState } from 'react'
import { ApiPromise } from 'services/ApiPromise'
import { Converters } from 'services/Converters'

type SupportPostSearchResults = {
  data: SupportPostModel['data'][]
}

const SupportPostSearchBar: FunctionComponent = () => {
  const convert = (input: any) => Converters.KeysConvert.ToLowerCase(input)
  const [isResultShowing, setIsResultShowing] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [searchResults, setSearchResults] = useState<SupportPostSearchResults | null>(null)
  const [axiosCancelToken, setAxiosCancelToken] = useState<CancelTokenSource | null>(null)
  async function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setSearchText(e.target.value)
    setIsResultShowing(true)
    await ApiPromise.Blog.SupportPostsByTitle(searchText).then((resp) => {
      const finalData = convert(resp.data)
      if (finalData.data.length > 0) {
        setSearchResults(finalData)
      } else {
        setSearchResults(null)
      }
    })
  }

  return (
    <Fragment>
      <div className="md:max-w-[650px] md:pl-2 w-full mx-auto">
        <form action="" className="bg-white flex items-center rounded-full relative">
          <button className="pl-5 h-10">
            <CdnImage fileName="search-btn.png" />
          </button>
          <input
            value={searchText}
            onChange={handleChange}
            type="text"
            placeholder="Search Knowledge Base"
            className="form-input rounded-full px-4 py-4 text-lg text-[#7b7b7d] w-full border-none focus:border-none focus:shadow-none focus:ring-0 focus:outline-none"
          />
          <AnimatePresence>
            {searchText && (
              <motion.div
                initial={{ y: -15, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -15, opacity: 0 }}
                transition={{ type: 'spring' }}
                className="absolute w-full bg-white rounded-md px-4 py-6 top-0 mt-[80px] shadow-lg"
              >
                {searchResults ? (
                  <div className="text-gray-800 text-base font-normal text-left">
                    {searchResults.data.map((data, index) => (
                      <Link key={index} href={`/support/${data.attributes.slug}`}>
                        <p onClick={() => setSearchText('')} className="text-gray-800 hover:text-[rgb(249,100,0)] cursor-pointer">
                          {data.attributes.title}
                        </p>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="text-gray-800 text-base font-normal">Keep typing for live search results</div>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </form>
      </div>
    </Fragment>
  )
}

export default SupportPostSearchBar
